'use client';
import { ReactNode } from 'react';
import useKeyboardShortcuts from '@/hooks/useKeyboardShortcuts';

interface AppWrapperProps {
  children: ReactNode;
}

export default function AppWrapper({ children }: AppWrapperProps) {
  useKeyboardShortcuts();
  return <>{children}</>;
}